module.exports = __webpack_public_path__ + "img/1791.37baba66.gif";